import * as React from "react";
import { LayerContext } from "../managers/LayerManager";

function useLayer(id: string) {
  const context = React.useContext(LayerContext);

  const removeLayer = React.useCallback(() => context.removeLayer(id), []);
  const updateLayer = React.useCallback(
    (element: React.ReactElement<any>) => context.updateLayer(id, element),
    []
  );

  return {
    removeLayer,
    updateLayer,
    parentElement: context.parentElement
  };
}

export default useLayer;
